export default "__VITE_ASSET__nlV54GUd__"